export default "__VITE_ASSET__DBIfhG5i__"